<!-- Full screen loading component -->
<div class="is-loading " style="width: 100vw; height: 100vh;"></div>
